import React from "react";

export const Image = ({ title, largeImage, smallImage, position, total, onOpen }) => {
  return (
    <a
      className="gallery-item"
      href={largeImage}
      aria-label={`${title} – Bild ${position} von ${total} vergrößern`}
      onClick={(e) => {
        // Mittelklick / "in neuem Tab öffnen" weiterhin zulassen
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        onOpen();
      }}
    >
      <img
        src={smallImage}
        alt={title}
        loading="lazy"
        decoding="async"
        width="1024"
        height="768"
      />
      <span className="gallery-item-overlay">
        <span className="gallery-item-title">{title}</span>
      </span>
    </a>
  );
};
